import { HttpService } from "./http.service";
import { RequestInputOutputParamsModel } from '../models/requestInputOutputParams.model';
import { ResultRequestModel } from "../models/resultRequest.model";
import { ChangePasswordModel } from "../models/changePassword.model";

const basePath = "/User";
const request = HttpService.handleRequest();

export const UserService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  insertOrUpdate,
  getGroupBranchByUserId,
  getGroupBranch,
  SaveUserBranchGroupd,
  getAlertDetailByUserIdByAlertId,
  setNewPassword,
  GetGroupBranchByUserApprove,
  getAllLocales,
  getLocalesLogin
};

async function getAll() {
  return request.get(basePath);
}


async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(`${basePath}`, data);
}

async function SaveUserBranchGroupd(data) {
  return request.post(`${basePath}/SaveUserBranchGroupd`, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function del(data) {
  return request.delete(basePath, { data });
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getGroupBranchByUserId(id) {
  return request.get(`${basePath}/GetGroupBranchByUserId/${id}`);
}

async function getLocalesLogin() {
  return request.get(`${basePath}/GetLocalesLogin/`);
}

async function getAllLocales(id?: number) {
  return request.get(`${basePath}/GetAllLocales/${id ?? null}`);
}

async function getGroupBranch() {
  return request.get(`${basePath}/GetGroupBranch/`);
}

async function getAlertDetailByUserIdByAlertId(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/GetAlertDetailListWithPagination`, data);
}


async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function setNewPassword(data: ChangePasswordModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/SetNewPassword`, data);
}

async function GetGroupBranchByUserApprove(id) {
  return request.get(`${basePath}/GetGroupBranchByUserApprove/${id}`);
}

export default UserService;